<template>
  <article
    class="comment"
    :class="{
      'comment--deleted': comment.deleted,
    }"
  >
    <div class="comment__author author">
      <div class="author__userpic">
        <userpic :url="author.userpic" />
      </div>
      <div class="author-data">
        <div class="author-data__wrapper">
          <a v-if="author.link" :href="author.link" class="author__name" target="_blank">{{ author.name }}</a>
          <span v-else class="author__name">{{ author.name }}</span>
          <span v-if="author.post" class="author__position">{{ author.post }}</span>
        </div>
      </div>
    </div>
    <div class="comment__content">
      <div v-if="comment.deleted">
        <span class="deleted-message">Комментарий удален</span>

        <button v-if="canRestore" class="comment-action" @click="restore">Восстановить</button>
      </div>

      <template v-else>
        <div class="comment__text">{{ comment.message }}</div>
        <div v-if="files.length" class="comment__files">
          <files :files="files" :actions="true" />
        </div>
      </template>
    </div>

    <footer class="comment__footer">
     
      <div class="comment__date">{{ comment.createdAt }}</div>
      <div v-if="canEdit && !comment.deleted" class="comment__actions">
        <template v-if="isCurrentUser">
          <button class="comment-action" @click="edit">Редактировать</button>
          <button class="comment-action comment-action--delete" @click="remove">Удалить</button>
        </template>
        <template v-else>
          <button class="comment-action" @click="reply">Ответить</button>
        </template>
      </div>
    </footer>
  </article>
</template>

<script>
import { mapState } from "vuex";

import { FileModel } from "./file-model";

import Files from "@/components/files";
import Userpic from "@/components/user/userpic";

export default {
  components: { Files, Userpic },

  props: ["comment", "removed", "canRestore", "canEdit"],

  data() {
    return {
      slide: 0,
      lightbox: false,
    };
  },

  computed: {
    ...mapState(["userId"]),

    authorId() {
      return this.comment.user.id || "";
    },

    author() {
      const { user, worker } = this.comment;
      const { name: userName } = user;

      if (worker) {
        const { photo, name, id, post } = worker;
        return {
          workerId: id,
          userpic: photo,
          name,
          link: `/?r=redesign#/personal-employee/${id}/summary`,
          post,
        };
      }

      return {
        name: userName,
      };
    },

    isCurrentUser() {
      return this.userId.toString() === this.authorId.toString();
    },

    files() {
      return this.comment.files.map(FileModel);
    },
  },

  methods: {
    edit() {
      this.$emit("edit");
    },
    remove() {
      this.$emit("remove");
    },
    reply() {
      this.$emit("reply");
    },
    restore() {
      this.$emit("restore");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.comment {
  .author {
    display: flex;

    &__userpic {
      margin-right: 10px;
    }

    &-data {
      display: flex;
      align-items: center;
      min-height: 34px;
      padding: 4px 0;

      &__wrapper {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
      }
    }

    &__name {
      font-size: 13px;
      font-weight: 500;
      margin-right: 12px;
    }

    a {
      color: $color-primary;
    }

    &__position {
      font-size: 11px;
      line-height: 1.2;
      color: #8e9cbb;
    }
  }

  &__content {
    padding-left: 44px;
    font-size: 13px;
  }

  &__footer {
    padding-left: 44px;
    margin-top: 10px;
    display: flex;
    align-items: center;
    line-height: 1;
  }

  &__date {
    font-size: 12px;
    color: #8e9cbb;
    margin-right: 15px;
  }

  &-action {
    background: transparent;
    font-size: 12px;
    color: $color-primary;
    font-weight: 500;
    padding: 0;
    margin-right: 15px;

    &--delete {
      color: $color-error;
    }

    &,
    &:hover,
    &:focus {
      border: none;
      outline: none;
    }
  }

  &__files {
    margin-top: 10px;
    /deep/ {
      .files__wrapper {
        margin-left: -2.5px;
        margin-right: -2.5px;
      }
      .file-preview {
        width: 55px;
        margin-left: 2.5px;
        margin-right: 2.5px;

        &-img {
          height: 50px;

          &__icon {
            width: 15px;
            height: 15px;
          }
        }

        &__name {
          display: none;
        }
      }
    }
  }

  &--deleted {
    .author {
      opacity: 0.5;
    }
  }

  .deleted-message {
    color: #8e9cbb;
    font-size: 13px;
    margin-right: 20px;
  }

  @media screen and (max-width: 700px) {
    .author {
      &-data {
        &__wrapper {
          flex-direction: column;
        }
      }
    }

    &__content {
      padding-left: 0px;
      margin-top: 8px;
    }

    &__footer {
      padding-left: 0px;
    }
  }
}
</style>
